import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import InstitutionForm, { defaultValues as institutionInitialState } from 'shared/account/components/InstitutionForm';
import { Controls, useFormHelpers } from 'shared/helper/form';
import { convertJsonToInstitutionInformationFormData, convertFormDataToInstitutionInformationUpdateRequest } from 'shared/view/user-conversion-service';
import FormSubmit from './FormSubmit';
var Form = Controls.Form,
  Text = Controls.Text;
export var defaultValues = {
  institution: institutionInitialState,
  city: ''
};
var InstitutionInformationForm = function InstitutionInformationForm(_ref) {
  var apiRoot = _ref.apiRoot,
    formData = _ref.formData,
    onUserInformationUpdated = _ref.onUserInformationUpdated,
    status = _ref.status,
    updateInstitutionInformation = _ref.updateInstitutionInformation,
    userIdentity = _ref.userIdentity;
  var methods = useForm({
    defaultValues: defaultValues
  });
  var _useFormHelpers = useFormHelpers(methods),
    preprocessData = _useFormHelpers.preprocessData,
    populateFormData = _useFormHelpers.populateFormData;
  useEffect(function () {
    if (formData) {
      populateFormData(convertJsonToInstitutionInformationFormData(formData));
    }
  }, [formData && formData.identity]);
  var handleUpdateInstitutionInformation = function handleUpdateInstitutionInformation(institutionInformationUpdateRequest) {
    return updateInstitutionInformation(apiRoot, userIdentity, institutionInformationUpdateRequest).then(function (_ref2) {
      var error = _ref2.error,
        user = _ref2.user;
      if (!error && user) {
        onUserInformationUpdated(user);
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: preprocessData(convertFormDataToInstitutionInformationUpdateRequest, handleUpdateInstitutionInformation)
  }, /*#__PURE__*/React.createElement(InstitutionForm, {
    displayInstitutionType: true,
    formStyles: {
      wrapper: 'mb-3'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    name: "city",
    label: "City",
    styles: {
      wrapper: 'mb-3'
    }
  }), /*#__PURE__*/React.createElement(FormSubmit, {
    disable: status.updating || !status.loaded,
    busy: status.updating
  })));
};
export default InstitutionInformationForm;